import { mergeMap } from 'rxjs/operators'
import { empty, of } from 'rxjs'
import { Epic } from 'interfaces/middleware'
import { TOGGLE_DISMISS_INSIGHT, INSIGHT_CTA_CLICK, INSIGHT_SHOWN } from 'actions/insightsActions'
import { InsightId } from 'interfaces/insights'
import { InsightEventName, INSIGHT_EVENT_CATEGORY } from 'components/features/beacon/types'
import { sendEventActionCreator } from 'components/features/beacon/actions'
import { byType } from 'rxOperators/byType'

// insightEpic emits actions of type SEND_EVENT, when something happens
export const insightEpic: Epic = (action$) =>
  action$.pipe(
    byType(INSIGHT_CTA_CLICK, INSIGHT_SHOWN, TOGGLE_DISMISS_INSIGHT),
    mergeMap((action) => {
      let name: InsightEventName | null = null
      let insight_id: InsightId | null = null

      switch (action.type) {
        case INSIGHT_CTA_CLICK:
          if (action.payload.insight) {
            name = action.payload.type
            insight_id = action.payload.insight.id

            const isFakeInsight = insight_id < 0
            if (isFakeInsight) {
              return empty()
            }
          }
          break

        case INSIGHT_SHOWN:
          name = 'shown'
          insight_id = action.payload.id
          break

        case TOGGLE_DISMISS_INSIGHT:
          name = action.payload.is_dismissed ? 'dismiss' : 'undismiss'
          insight_id = action.payload.insight.id
          break
      }

      return name && insight_id
        ? of(
          sendEventActionCreator(INSIGHT_EVENT_CATEGORY, {
            name,
            data: { insight_id },
          })
        )
        : empty()
    }),
  )
